import { Spin } from 'antd';
const Loading = () => {
  const style = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  };
  return (
    <div style={style}>
      <Spin size="large" />
    </div>
  );
};

export default Loading;
